import React from 'react';
import ReactDOM from 'react-dom';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import LaboratoryResultsToDescribeWrapper from '../LaboratoryResultsToDescribeWrapper/LaboratoryResultsToDescribeWrapper';

loadDOMComponent({
	selector: 'react-laboratory-results-to-describe-list',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<LaboratoryResultsToDescribeWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
